import React from 'react';
import styled from 'styled-components';
import { MenuItems } from './FooterMenuItems';
import PipeIcon from '../../images/Pipe';

export const MenuContainer = styled.div`
  display: flex;
  gap: 1em;
  align-items: center;
  justify-content: flex-start;
`;

export const MenuItemContainer = styled.div`
  font-size: ${({ theme }) => theme.fontSize.m};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  letter-spacing: 0.004em;
`;

type IFooterMenu = {
  items: MenuItems[];
};

const FooterMenu: React.FC<IFooterMenu> = ({ items }) => {
  const menuItems: any = [];
  items?.forEach(
    (item: MenuItems, index: number, footerMenuItems: MenuItems[]) => {
      menuItems.push(
        <MenuItemContainer key={item.name}>{item.name}</MenuItemContainer>,
      );
      if (index !== footerMenuItems.length - 1) {
        menuItems.push(
          <MenuItemContainer key={index}>
            <PipeIcon />
          </MenuItemContainer>,
        );
      }
    },
  );

  return <MenuContainer>{menuItems}</MenuContainer>;
};

export default FooterMenu;
